import { render } from "./PersonalInfoPolicy20260901Content.vue?vue&type=template&id=7088e2e8"
import script from "./PersonalInfoPolicy20260901Content.vue?vue&type=script&lang=js"
export * from "./PersonalInfoPolicy20260901Content.vue?vue&type=script&lang=js"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__